/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import LeftArrowIcon from 'material-ui-icons/ArrowBack';
import RightArrowIcon from 'material-ui-icons/ArrowForward';
import EventIcon from 'material-ui-icons/Event';
import {
    handlecheckInChangeFactory, handlecheckOutChangeFactory,
    handleNightsChangeFactory, handleNightsEnterFactory
} from '../Utils/FilterChangeFunctions';
import moment from 'moment';

import Room from './Room';
import { translate } from 'react-i18next';
import { Grid, TextField } from 'material-ui';


import {
    handleSubmitFactory, setSelectedSuggestionFactory, commonValidateAndCase
} from './CommonFunctions';

import AbstractSearchForm from './AbstractSearchForm';
import { MenuItem } from 'material-ui';
import { DatePicker } from 'material-ui-pickers';
import FullTextSearchField from './FullTextSearchField';
import { Button } from 'material-ui';
import { Typography } from 'material-ui';
import { CircularProgress } from 'material-ui';
import SelectSimple from '../../ui/SelectSimple';
import { componentDidMountFactory } from './CommonFunctions';

import { connect } from 'react-redux';
import { setSelection } from '../../actions/selectSuggestionActions';


const styles = {
    avatar: {
        backgroundColor: 'dark-grey',
        color: 'grey',
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    roomNumberTextField: {
        width: '140px',
        marginBottom: '32px',
    },
    footNoteText: {
        marginTop: '16px',
        fontWeight: 300,
        paddingTop: 0
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '24px'
    }
};

const roomsValues = Array.from(Array(6).keys());
roomsValues.shift();

/**
 * Componente de busqueda general
 *
 * @author Luciano Bustos
 */
class SearchForm extends AbstractSearchForm {
    constructor(props) {
        super(props);

        const { user, classes, tab } = props;
        this.accountName = user ? user.accountName.toLowerCase() : 'default';
        this.currentUser = user;
        this.tab = tab;
        this.prevNigths = 1;
        this.state = this.initState(classes, tab);
    }

    initState = (classes, tab) => {
        let inState = {
            tab: tab,
            classes: classes,
            inputError: false,
            totalRooms: 1,
            rooms: [
                {
                    adults: 2,
                    kids: [],
                    mealPlan: 'ALL',
                },
            ],
            checkIn: moment(this.START_DAY),
            checkOut: moment(this.START_DAY).add(1, 'days'),
            nights: 1,
            value: '',
            suggestions: [],
            selectedSuggestion: {},
            loading: false,

            isDestListForm: this.tab.type.id === 'DS' ? true : false,
            isHotelListForm: this.tab.type.id === 'HS' ? true : false,


            exclusiveDestinationSelected: this.getInitialExclusiveDestinationValue(),

            data: null,
        };
        return inState;
    };

    componentDidMount = () => {
        componentDidMountFactory(this)();
    }

    getInitialExclusiveDestinationValue = () => {
        if (this.tab.type.id === 'DS' && this.tab.destinations.length === 1) {
            return JSON.stringify(this.tab.destinations[0]);
        }
        if (this.tab.type.id === 'HS' && this.tab.hotelDestinations.length === 1) {
            return this.tab.hotelDestinations[0].hotelIds;
        }
    };

    handleClose = () => {
        this.props.onClose(this.state);
    };

    handleFault = (error, query) => {
        alert(error.message);
    }

    handleCancel = () => {
        this.props.onClose(null);
    };

    handleHotelListChange = destinationId => {
        
        this.dispatchSelectionState({
            currentIndex: destinationId,
            exclusiveDestinationSelected: this.tab.hotelDestinations[destinationId].hotelIds
        });

        this.setState({
            exclusiveDestinationSelected: this.tab.hotelDestinations[destinationId].hotelIds,
        });
    };

    handleDestinationChange = destinationId => {
        const exclusiveDestinationSelected = JSON.stringify(this.tab.destinations[destinationId]);
        this.dispatchSelectionState({
            currentIndex: destinationId,
            exclusiveDestinationSelected
        });
        this.setState({
            exclusiveDestinationSelected: exclusiveDestinationSelected,
        });
    };

    dispatchSelectionState(data) {
        if (!data.hasOwnProperty('currentIndex') || 
            !data.hasOwnProperty('exclusiveDestinationSelected')
        ) {
            throw new Error('Todos los campos son necesarios para cargar el estado del SelectSimple');
        }
        this.props.dispatch(setSelection(data));
    }

    /**
     * Return the formatted list of hotels ready to be used by the select native component
     */
    formattedHotelList = (destinations) => {
        return destinations.map((dest, idx) => {
            dest.newLabel = dest.label.value;
            dest.idx = idx;
            return dest;
        });
    }

    getFormattedDestination = (destination) => {
        const normalizedCountry = commonValidateAndCase(destination.countryName);
        const normalizedProvince = commonValidateAndCase(destination.countryDivisionName);
        const normalizedCity = commonValidateAndCase(destination.cityName);
        const normalizedCoast = commonValidateAndCase(destination.coastName);

        let locationMessage = [];
        if (normalizedCoast !== '') {
            locationMessage.push(normalizedCoast);
        }
        if (normalizedCity !== '') {
            locationMessage.push(normalizedCity);
        }
        if (normalizedProvince !== '') {
            locationMessage.push(normalizedProvince);
        }
        if (normalizedCountry !== '') {
            locationMessage.push(normalizedCountry);
        }
        locationMessage = locationMessage.join(', ');
        return locationMessage;
    }
    /**
     * Return the formatted list of destinations ready to be used by the select native component
     */
    formattedDestinationsList = (destinations) => {
        return destinations.map((dest, idx) => {
            dest.idx = idx;
            dest.newLabel = this.getFormattedDestination(dest);
            return dest;
        });
    }

    render() {
        const { classes, t, isDisabled, tab, widget1Active } = this.props;
        const { value } = this.state;
        const totalAdults = this.state.rooms.reduce((acc, r) => acc + r.adults, 0);
        const totalKids = this.state.rooms.reduce((acc, r) => acc + r.kids.length, 0);

        const customHeightForWidget1 = widget1Active ? ' widgetActive' : '';

        let firstColumns = '';

        if (tab.type.id === 'H') {
            firstColumns =
                <FullTextSearchField
                    setSelectedSuggestion={setSelectedSuggestionFactory(this)}
                    value={value}
                    inputError={this.state.inputError}
                    width='100%'
                    isDisabled={isDisabled} />;
        }
        if (tab.type.id === 'DS') {
            if (tab.destinations.length <= 1) {
                tab.image ?
                    (firstColumns = <div className={tab.image.degraded ? 'imageGradient' : ''}><img src={tab.image.url ? tab.image.url : ''} alt="Destination Logo" className="cmsImageSearchForm" /></div>) :
                    firstColumns = <h1>{this.getFormattedDestination(tab.destinations[0])}</h1>;
            } else {
                firstColumns =
                    <SelectSimple id={'dsSelectionList'}
                        label={t('HOME.DESTINATION')}
                        labelProp="newLabel" codeProp="idx"
                        selection={value ? value : null}
                        disabled={this.state.loading || isDisabled}
                        onChange={(val) => {
                            this.handleDestinationChange(val);
                        }}
                        options={this.formattedDestinationsList(tab.destinations)} />;
            }
        }
        if (tab.type.id === 'HS') {
            if (tab.hotelDestinations.length <= 1) {
                tab.image ?
                    (firstColumns = <div className={tab.image.degraded ? 'imageGradient' : ''}><img src={tab.image.url ? tab.image.url : ''} alt="Hotel Logo" className="cmsImageSearchForm" /></div>) :
                    firstColumns = <h1>{tab.hotelDestinations[0].label.value}</h1>;
            } else {
                firstColumns =
                    <SelectSimple id={'hsSelectionList'}
                        label={t('HOME.DESTINATION')}
                        labelProp="newLabel" codeProp="idx"
                        selection={value ? value : null}
                        onChange={(val) => {
                            this.handleHotelListChange(val);
                        }}
                        options={this.formattedHotelList(tab.hotelDestinations)} />;
            }
        }

        const hideScrollbar = this.state.rooms && this.state.rooms.length < 3 ? 'hideScrollbar' : '';

        return (

            <div className="SearchForm">

                <table width="100%" className="cmsTable">
                    <tbody>
                        <tr>
                            <td colSpan={'4'}>
                                {firstColumns}
                            </td>
                        </tr>
                        <tr>
                            <td className="cmsFirstColumn">
                                <DatePicker
                                    keyboard
                                    label={t('COMMON.CHECK_IN')}
                                    format={'DD/MM/YYYY'}
                                    autoOk fullWidth
                                    leftArrowIcon={<LeftArrowIcon />}
                                    rightArrowIcon={<RightArrowIcon />}
                                    disablePast
                                    keyboardIcon={
                                        <EventIcon className="cmsIcon" />
                                    }
                                    value={this.state.checkIn}
                                    onChange={handlecheckInChangeFactory(this)}
                                    animateYearScrolling={false} className="cmsFormContainer"
                                    disabled={this.state.loading || isDisabled}
                                    minDateMessage={t('HOME.DATE_VALIDATION')}
                                    invalidDateMessage={t('HOME.INVALID_FORMAT')}
                                />
                            </td>
                            <td className="cmsSearchNight">
                                <TextField
                                    label={t('COMMON.NIGHTS')}
                                    value={this.state.nights}
                                    onChange={handleNightsChangeFactory(this)}
                                    onBlur={(e) => { handleNightsEnterFactory(e, this); }}
                                    onKeyDown={(e) => { handleNightsEnterFactory(e, this); }}
                                    type="number"
                                    fullWidth
                                    className="cmsFormContainer"
                                    inputProps={{ min: 1, max: this.MAX_NIGHTS }}
                                    disabled={this.state.loading || isDisabled}
                                />
                            </td>
                            <td>
                                <DatePicker
                                    keyboard
                                    label={t('COMMON.CHECK_OUT')}
                                    className="cmsFormContainer"
                                    format={'DD/MM/YYYY'}
                                    autoOk fullWidth
                                    leftArrowIcon={<LeftArrowIcon />}
                                    rightArrowIcon={<RightArrowIcon />}
                                    disablePast
                                    keyboardIcon={
                                        <EventIcon className="cmsIcon" />
                                    }
                                    value={this.state.checkOut}
                                    onChange={handlecheckOutChangeFactory(this)}
                                    animateYearScrolling={false}
                                    disabled={this.state.loading || isDisabled}
                                    minDateMessage={t('HOME.DATE_VALIDATION')}
                                    invalidDateMessage={t('HOME.INVALID_FORMAT')} />
                            </td>
                            <td className="cmsSearchRooms">
                                <TextField
                                    select
                                    label={t('COMMON.ROOMS')}
                                    name={'totalRooms'}
                                    className="cmsFormContainer"
                                    value={this.state.totalRooms}
                                    onChange={this.handleTotalRoomChange}
                                    InputLabelProps={{
                                        className: classes.inputLabel,
                                    }}
                                    SelectProps={{
                                        MenuProps: {
                                            className: classes.menu,
                                        },
                                    }}
                                    fullWidth
                                    disabled={this.state.loading || isDisabled}>
                                    {roomsValues.map(option => (
                                        <MenuItem key={option} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className={'roomsContainer ' + hideScrollbar + customHeightForWidget1}>
                    {
                        this.state.rooms.map((r, number) => (
                            <Room
                                key={number}
                                displayIcon={false}
                                displayTitle={true}
                                loading={this.state.loading || isDisabled}
                                number={number}
                                {...r}
                                handleAdultChange={this.handleAdultChange}
                                handleKidsChange={this.handleKidsChange}
                                handleKidsAgeChange={this.handleKidsAgeChange}
                            />
                        ))
                    }
                </div>
                <Grid container justify="space-between" alignItems="center">
                    <Grid item xs={6}>
                        <Typography className="caption-form-description">{t('HOME.REQUIRED_FIELD')}</Typography>
                        <Typography className="caption-form-description">{t('HOME.BABIES_AS_CHILDREN')}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Button
                            variant="raised"
                            color="secondary"
                            onClick={() => { handleSubmitFactory(this)(); }}
                            //disabled={this.state.loading}
                            size={'large'}
                            fullWidth
                            disabled={isDisabled}
                            className="cmsButtonSearch">
                            {this.state.loading && <CircularProgress size={24} />}
                            {t('HOME.SEARCH_BUTTON')}
                        </Button>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

SearchForm.propTypes = {
    classes: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    tab: PropTypes.object.isRequired,
    onClose: PropTypes.func,
    isDisabled: PropTypes.bool
};

const mapStateToProps = state => ({

})

SearchForm.defaultProps = {
    widget1Active: false
};

export default connect(mapStateToProps)(translate('translations')(withStyles(styles)(SearchForm)));


// WEBPACK FOOTER //
// ./src/components/SearchContent/SearchForm.js